import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { FLIGHT_CLASSES } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/constants';
import type { PropsFromRedux } from '.';
import FlightsByClass from '../../../../../../components/Flights/FlightsByClass';

const cssTransitionProps = {
  timeout: 300,
  classNames: 'fade',
};

const FlightsResults = (props: PropsFromRedux): JSX.Element => {
  const {
    flightClass,
    economyFlights = [],
    businessFlights = [],
    flightCount,
    setVisibleFlights,
    visibleFlights,
  } = props;
  const isActive = flightCount === 1;
  return (
    <TransitionGroup>
      {flightClass === FLIGHT_CLASSES.ECONOMY ? (
        <CSSTransition key={FLIGHT_CLASSES.ECONOMY} {...cssTransitionProps}>
          <FlightsByClass
            items={economyFlights}
            isActive={isActive}
            setVisibleFlights={setVisibleFlights}
            visibleFlightsCount={visibleFlights}
          />
        </CSSTransition>
      ) : (
        <CSSTransition key={FLIGHT_CLASSES.BUSINESS} {...cssTransitionProps}>
          <FlightsByClass
            items={businessFlights}
            isActive={isActive}
            setVisibleFlights={setVisibleFlights}
            visibleFlightsCount={visibleFlights}
          />
        </CSSTransition>
      )}
    </TransitionGroup>
  );
};

export default FlightsResults;
